import {scriptonload} from '../modules/scriptonload';

var codeInsert = function(el){
        var btn = el.querySelector('[data-codeInsert-btn]'),
            clipboard,
            init = function(){
                clipboard = new ClipboardJS(btn);
                clipboard.on('success', function(e) {
                        el.classList.toggle('js-active');
                        if(el.classList.contains('js-active')){
                                alert('Код скопирован в буфер обмена');
                            }

                            e.clearSelection();
                    });
                el.classList.add('js-loaded');
            };

            //
            scriptonload(APP.vendors.clipboard, function(){
                init();
            });
    }

export {codeInsert};